export const columnHeaders = {
  salaryHeader: "salary",
  countryHeader: "country",
  cityHeader: "city",
  stateHeader: "state",
  educationHeader: "education",
  positionHeader: "position",
  industryHeader: "industry",
  experienceHeader: "experience",
  genderHeader: "gender",
};

export const salaryRanges = [
  "under $25K",
  "$25K–50K",
  "$50K–75K",
  "$75K–100K",
  "$100K–125K",
  "$125K–150K",
  "$150K–175K",
  "$175K–200K",
  "over $200K",
];

// optional paragraph below the main form header
export const formIntro = `Want to know how your salary compares to others' across the globe?

Or what you can expect as you progress up the career ladder?

Fill in a few fields below, explore the advanced filters, and the salary calculator will do the rest for you!
`;

export const percentileExplanation = `
The percentiles here indicate the annual salary below which a given percentage (25%, 50% or 75%) of observations in the observation group falls; i.e., 75th percentile = $100K means that 75% of people earn $100K or less annually (only 25% of people earn more). The 50th percentile is the central value, also known as the median.
`;

export const positionsLookupArray = [
  "Associate Product Marketing Manager",
  "Product Marketing Manager",
  "Senior Product Marketing Manager",
  "(People) Manager of Product Marketing",
  "Director of Product Marketing",
  "VP of Product Marketing",
];
export const experienceLookupArray = [
  "< 3 years",
  "3-5 years",
  "5-10 years",
  "10 or more years",
];
